// import { ErrorBoundary } from "react-error-boundary";
import { useGamePlay } from "../../../redux/gamePlay";
// import {
//   ERROR_PLAYER,
//   sendPingData,
//   setError,
//   setErrorMsg,
// } from "../../../ducks/ping";
import Player from "./Player";
import OpponentTime from "./OpponentTime";
export default function OpponentPlayer() {
  const { gameEnded, isUserTurn, opponent } = useGamePlay();

  const isUser = false;
  const playerProps = {
    isUser,
    ...opponent,
    gameEnded,
    turn: !isUserTurn,
  };

  return (
    // <ErrorBoundary
    //   fallbackRender={({ error, resetErrorBoundary }) => null}
    //   onError={(error, info: { componentStack: string }) => {
    //     setError(ERROR_PLAYER);
    //     setErrorMsg({
    //       errorMsg:
    //         "OpponentPlayer4 " +
    //         error.message +
    //         " " +
    //         JSON.stringify(playerProps),
    //       componentStack: info.componentStack,
    //     });
    //     sendPingData();
    //   }}
    // >
    <Player {...playerProps}>
      <OpponentTime isRunning={!isUserTurn} />
    </Player>
    // </ErrorBoundary>
  );
}
